import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import PropdocsModal from '../../../modal/PropdocsModal';
import styles from '../../../document-wizard/document-wizard-header/components/headerActions/sendToPreparingToSignInternal/styles.module.scss';

interface ShareExecutedDocumentModalProps {
  onHide: () => void;
  isLoading: boolean;
  onConfirm: () => void;
  show: boolean;
}

const ShareExecutedDocumentModal = ({ onConfirm, onHide, isLoading, show }: ShareExecutedDocumentModalProps) => {
  return (
    <PropdocsModal
      show={show}
      setShow={onHide}
      size="lg"
      title={
        <FormattedMessage
          id="document-wizard-modal.send-for-signing"
          defaultMessage="Send Document to Counterparty"
        />
      }
      disableClose={isLoading}
    >
      <>
        <div className={styles.main} style={{ marginBottom: '1.5rem' }}>
          Your counterparty will not be able to edit this document since it has already been signed.
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', paddingTop: '1.5rem' }}>
          <Button variant="link" className="text-secondary" onClick={onHide} disabled={isLoading}>
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
          <Button variant="secondary" onClick={onConfirm} disabled={isLoading} className={styles['cancel-button']}>
            {isLoading ? (
              <FormattedMessage id="common.sending" defaultMessage="Sending..." />
            ) : (
              <FormattedMessage id="common.send" defaultMessage="Send" />
            )}
          </Button>
        </div>
      </>
    </PropdocsModal>
  );
};
export default ShareExecutedDocumentModal;
